import { render, staticRenderFns } from "./WPDivider.vue?vue&type=template&id=6018834c"
import script from "./WPDivider.vue?vue&type=script&lang=ts"
export * from "./WPDivider.vue?vue&type=script&lang=ts"
import style0 from "./WPDivider.vue?vue&type=style&index=0&id=6018834c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports